import React, { useEffect, useState } from "react";
import { SettingsIcon } from "../../../assets/icons/iconsProvider";
import ShopifyPresetsMappingModal from "../../../views/Settings/ShopifyPresets/AddNewPreset/ShopifyPresetsMappingModal";
import { inventoryActions, shopifyActions } from "../../../redux/actions";
import { connect } from "react-redux";
import {
  getDefaultFields,
  getMappedShopifyFields,
  isSpinnerEnabled,
  LoadingIndicator,
} from "../../utility";
import {
  defaultGlobalShopifyPresetObject,
  shopifyConstants,
} from "../../../constants";

const ProductShopifyMappingSettingModal = ({
  inventory,
  spinnerArray,
  currentStore,
  productDataObject,
  color = "text-white",
  getShopifyMappingsById,
  setProductShopifySettings,
  createProductMappingObject,
  isBatchProduct = false,
  setProductDataObject = () => {},
  isShowInStoreOnlineQuantityCheck = false,
  handleStoreAndOnlineQuantityChange,
}) => {
  const { productShopifySettings } = inventory;

  const [isShopifyPresetModal, setIsShopifyPresetModal] = useState(false);
  const [initialMapping, setInitialMapping] = useState(false);
  const toggleShopifyMappingModal = () => {
    if (isShopifyPresetModal) {
      setInitialMapping(false);
    }
    setIsShopifyPresetModal((prev) => !prev);
  };

  const handleSettingClick = () => {
    setInitialMapping(false);
    setProductShopifySettings({});
    toggleShopifyMappingModal();
    getShopifyMappingsById(
      currentStore?.id,
      productDataObject?.shopifySettingId ||
        productDataObject?.shopifySettingsObject?.marginObject?.id ||
        productShopifySettings?.marginObject?.id

      // productShopifySettings?.marginType?.isDefault || isBatchProduct
      //   ? productDataObject?.shopifySettingId
      //   : productShopifySettings?.marginObject?.id
    );
  };

  const handleSaveMappning = (updatedFields) => {
    let dataToUpdate = {
      ...productShopifySettings?.marginObject,
      isOnlineQuantity: !!updatedFields?.isOnlineQuantity,
      shopifyMapping: getMappedShopifyFields(updatedFields),
    };

    createProductMappingObject(
      currentStore?.id,
      dataToUpdate,
      toggleShopifyMappingModal,
      (data) => {
        setProductDataObject({
          ...productDataObject,
          shopifySettingId: data.id,
          shopifySettingsObject: {
            ...productDataObject?.shopifySettingsObject,
            marginObject: data,
          },
          isOnlineQuantity: dataToUpdate.isOnlineQuantity,
        });
      }
    );
    if (isShowInStoreOnlineQuantityCheck) {
      handleStoreAndOnlineQuantityChange(!!updatedFields?.isOnlineQuantity);
    }
  };

  useEffect(() => {
    if (productShopifySettings?.marginObject?.id) {
      setInitialMapping(getDefaultFields(productShopifySettings?.marginObject));
    }
  }, [productShopifySettings?.marginObject]);

  return (
    <>
      <span
        className={`cursor-pointer ${
          isSpinnerEnabled(
            spinnerArray,
            shopifyConstants.GET_SHOPIFY_PRESETS_BY_ID
          )
            ? "pe-none"
            : ""
        }`}
        onClick={() => {
          handleSettingClick();
        }}
      >
        {isSpinnerEnabled(
          spinnerArray,
          shopifyConstants.GET_SHOPIFY_PRESETS_BY_ID
        ) ? (
          <LoadingIndicator color={color} />
        ) : (
          <SettingsIcon className={"shopify-setting-icon"} />
        )}
      </span>
      {initialMapping && (
        <ShopifyPresetsMappingModal
          isShowSkeleton={isSpinnerEnabled(
            spinnerArray,
            shopifyConstants.GET_SHOPIFY_PRESETS_BY_ID
          )}
          initialMappings={initialMapping}
          handleSaveClick={handleSaveMappning}
          isShopifyMappingModal={isShopifyPresetModal}
          toggleShopifyMappingModal={toggleShopifyMappingModal}
          isOnlineQuantity={!!productDataObject?.isOnlineQuantity}
          isShowInStoreOnlineQuantityCheck={isShowInStoreOnlineQuantityCheck}
        />
      )}
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  inventory: state.inventory,
  currentStore: state.store.currentStore,
  spinnerArray: state.system.spinnerArray,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getShopifyMappingsById: (storeId, id) =>
    dispatch(shopifyActions.getShopifyMappingsById(storeId, id)),
  createProductMappingObject: (
    storeId,
    data,
    toggleShopifyMappingModal,
    callBack
  ) =>
    dispatch(
      shopifyActions.createProductMappingObject(
        storeId,
        data,
        toggleShopifyMappingModal,
        callBack
      )
    ),
  setProductShopifySettings: (data) =>
    dispatch(inventoryActions.setProductShopifySettings(data)),
});

//-------Export AddNewUser Component
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductShopifyMappingSettingModal);
